import { useQuery } from 'react-query';
import { Note } from '~/model/Notes/notes';
import { model as clientNoteModel } from '../notes';

export const clientNoteQueryKey = (clientId, noteId) => ['client', clientId, 'note', noteId];

export const useClientNote = (clientId, noteId) =>
  useQuery<Note>(clientNoteQueryKey(clientId, noteId), () => clientNoteModel(clientId).get(noteId));
